import axios from "axios";
import { Config } from "./config";

const AX = axios.create({
  baseURL: Config.baseUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Interceptor para adjuntar el token de acceso
AX.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
); 

// Interceptor para manejar errores de respuesta
AX.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Si el error es 401 y no se ha intentado ya renovar el token
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) {
          throw new Error("No refresh token found.");
        }

        // Solicitar un nuevo token de acceso
        const response = await axios.post(
          `${Config.baseUrl}/token/refresh/`,
          { refresh: refreshToken },
          {
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );

        const newToken = response.data.access;
        localStorage.setItem("accessToken", newToken);


        // Simplemente reintentamos la petición original
        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
        return AX(originalRequest);

      } catch (refreshError) {
        console.log("El refresh token ha expirado o es inválido.");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("authUser");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    // Rechazar el error si no es un 401
    return Promise.reject(error);
  }
);

export default AX;